import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950" role="contentinfo" aria-label="页脚">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto py-14 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-2">
              <Link to="/" className="inline-flex items-center gap-2 mb-4" aria-label="韩漫首页">
                <span className="font-heading text-2xl font-bold text-background-50 tracking-tight">韩漫</span>
                <span className="font-sans text-sm text-background-300 font-light">comic.kr</span>
              </Link>
              <p className="text-sm text-foreground-300 leading-relaxed max-w-sm">
                韩漫漫画网站作为海量正版漫画的在线阅读平台，提供免费的韩国漫画大全。每日更新热门韩漫，高清画质、流畅阅读，让您享受最优质的漫画阅读体验。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="哔哩哔哩" rel="nofollow">
                  <i className="ri-bilibili-line text-background-50 text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-background-300 uppercase tracking-wider mb-4">快速导航</h4>
              <ul className="flex flex-col gap-2.5">
                <li><Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">首页</Link></li>
                <li><Link to="/category/rexue" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">分类浏览</Link></li>
                <li><Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">排行榜</Link></li>
                <li><Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">最新更新</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-background-300 uppercase tracking-wider mb-4">热门分类</h4>
              <ul className="flex flex-col gap-2.5">
                <li><Link to="/category/rexue" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">热血漫画</Link></li>
                <li><Link to="/category/lianai" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">恋爱漫画</Link></li>
                <li><Link to="/category/qihuan" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">奇幻漫画</Link></li>
                <li><Link to="/category/wuxia" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">武侠漫画</Link></li>
                <li><Link to="/category/dushi" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">都市漫画</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-background-300 uppercase tracking-wider mb-4">帮助中心</h4>
              <ul className="flex flex-col gap-2.5">
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">用户协议</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">隐私政策</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">版权声明</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">联系我们</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">常见问题</Link></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">&copy; {new Date().getFullYear()} 韩漫漫画网站. 保留所有权利.</p>
            <div className="flex items-center gap-3">
              <Link to="/about" className="text-xs text-foreground-400 hover:text-background-50 transition-colors">隐私政策</Link>
              <span className="text-foreground-600">|</span>
              <Link to="/about" className="text-xs text-foreground-400 hover:text-background-50 transition-colors">服务条款</Link>
              <span className="text-foreground-600">|</span>
              <Link to="/about" className="text-xs text-foreground-400 hover:text-background-50 transition-colors">版权声明</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}